/**
 * Recently Viewed Products functionality
 * Tracks products viewed by users and stores them in localStorage
 */
(function() {
  'use strict';

  const STORAGE_KEY = 'recentlyViewed';
  const MAX_ITEMS = 50; // Maximum number of recently viewed items to store
  
  console.log('Recently viewed script loaded, STORAGE_KEY:', STORAGE_KEY);
  
  // Get recently viewed products from localStorage
  function getRecentlyViewed() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Error reading recently viewed:', e);
      return [];
    }
  }
  
  // Save recently viewed products to localStorage
  function saveRecentlyViewed(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.error('Error saving recently viewed:', e);
    }
  }
  
  // Add a product to recently viewed
  function addToRecentlyViewed(productData) {
    if (!productData || !productData.id) {
      console.warn('Invalid product data for recently viewed:', productData);
      return;
    }
    
    console.log('addToRecentlyViewed called with:', productData);
    
    let recentlyViewed = getRecentlyViewed();
    console.log('Current recently viewed before adding:', recentlyViewed, 'count:', recentlyViewed.length);
    
    // Remove duplicate if exists
    recentlyViewed = recentlyViewed.filter(item => item.id !== productData.id);
    
    // Add to beginning of array
    const newItem = {
      id: productData.id,
      title: productData.title || 'Product',
      price: productData.price || '0',
      image: productData.image || '',
      url: productData.url || window.location.href,
      viewedAt: new Date().toISOString()
    };
    
    recentlyViewed.unshift(newItem);
    
    // Limit to MAX_ITEMS
    if (recentlyViewed.length > MAX_ITEMS) {
      recentlyViewed = recentlyViewed.slice(0, MAX_ITEMS);
    }
    
    console.log('Saving recently viewed, new count:', recentlyViewed.length);
    saveRecentlyViewed(recentlyViewed);
    
    // Verify it was saved
    const saved = getRecentlyViewed();
    console.log('Verified recently viewed after save:', saved.length, 'items');
    if (saved.length > 0) {
      console.log('First item:', saved[0]);
    }
    
    // Dispatch event
    document.dispatchEvent(new CustomEvent('recentlyViewedUpdated', { 
      detail: { product: productData, recentlyViewed } 
    }));
    
    console.log('Added to recently viewed:', productData.id, '- Total items:', recentlyViewed.length);
  }
  
  // Get product data from current page
  function getProductDataFromPage() {
    // Try to get from product page
    const productPage = document.querySelector('.product-page, .product-info');
    if (productPage) {
      const titleEl = document.querySelector('h1.product-info__title, h1');
      const priceEl = document.querySelector('.price, .product-info__price, .price-display__value');
      const imageEl = document.querySelector('[data-gallery-main-image], .product-gallery img, .product-page__media img');
      const urlEl = document.querySelector('link[rel="canonical"]');
      
      // Get product ID from data attribute or extract from URL
      const productIdElement = document.querySelector('[data-product-id]');
      const productId = productIdElement?.getAttribute('data-product-id') || 
                        document.querySelector('.product-page__info')?.getAttribute('data-product-id') ||
                        window.location.pathname.match(/\/products\/([^\/]+)/)?.[1] || '';
      
      // Also try to get product handle from URL (more reliable)
      const productHandle = window.location.pathname.match(/\/products\/([^\/]+)/)?.[1] || '';
      
      // Use handle as ID for tracking (or product ID if available)
      const trackingId = productId || productHandle;
      
      if (trackingId) {
        const productData = {
          id: trackingId,
          handle: productHandle,
          title: titleEl?.textContent?.trim() || document.title?.split(' - ')[0] || 'Product',
          price: priceEl?.textContent?.trim() || '0',
          image: imageEl?.src || imageEl?.currentSrc || '',
          url: urlEl?.href || window.location.href
        };
        
        console.log('Extracted product data:', productData);
        return productData;
      }
    }
    
    return null;
  }
  
  // Track product view on product pages
  function trackProductView() {
    // Only track on product pages
    if (!window.location.pathname.includes('/products/')) {
      console.log('Not a product page, skipping tracking');
      return;
    }
    
    console.log('Tracking product view on:', window.location.pathname);
    
    // Try multiple times to ensure DOM is loaded
    let attempts = 0;
    const maxAttempts = 5;
    
    function tryTrack() {
      attempts++;
      const productData = getProductDataFromPage();
      
      if (productData && productData.id) {
        console.log('Product data found, adding to recently viewed:', productData);
        addToRecentlyViewed(productData);
      } else {
        if (attempts < maxAttempts) {
          console.log(`Attempt ${attempts}: Product data not ready, retrying...`);
          setTimeout(tryTrack, 300);
        } else {
          console.warn('Could not extract product data after', maxAttempts, 'attempts');
        }
      }
    }
    
    // Start tracking after a short delay
    setTimeout(tryTrack, 500);
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackProductView);
  } else {
    trackProductView();
  }
  
  // Also track when navigating via history
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      trackProductView();
    }
  });
  
  // Export for use in other scripts
  window.RecentlyViewedManager = {
    get: () => getRecentlyViewed(),
    add: (productData) => addToRecentlyViewed(productData),
    clear: () => {
      saveRecentlyViewed([]);
      document.dispatchEvent(new CustomEvent('recentlyViewedUpdated', { 
        detail: { recentlyViewed: [] } 
      }));
    },
    remove: (productId) => {
      let recentlyViewed = getRecentlyViewed();
      recentlyViewed = recentlyViewed.filter(item => item.id !== productId);
      saveRecentlyViewed(recentlyViewed);
      document.dispatchEvent(new CustomEvent('recentlyViewedUpdated', { 
        detail: { recentlyViewed } 
      }));
      return true;
    }
  };
})();

